import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";

const ProgressMap = ({ crInfo, productInfo }) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const add_product = useRef(null);
  const navigate = useNavigate();
  const state = {
    openProductModal: true,
  };

  // Function to handle the button click
  const handleClickAddProduct = () => {
    // Access the button using the ref
    navigate("/homepage/products", { state });
  };
  const handleClickAddBankCR = () => {
    // Access the button using the ref
    navigate("/homepage/company", {
      state: {
        openCompanyModal: true,
      },
    });
  };
  return (
    <div
      className="mx-1 col-sm-12 py-3 my-3"
      style={{
        borderRadius: "20px",
        width: "auto",
        position: "relative",
        paddingTop: "30px",
        height: "227px",
        maxHeight: "227px",
      }}
    >
      <div className="stepper-wrapper">
        <div
          className="stepper-item completed go_to_user"
          style={{ pointerEvents: "none" }}
        >
          <div className="step-counter fa-lg fa fa-check"></div>
          <button
            className="step-btn step-name-completed btn btn-lg mt-3"
            type="button"
          >
            {t["User Profile"]}
          </button>
        </div>
        <div
          className="stepper-item completed website_settings"
          style={{ pointerEvents: "none" }}
        >
          <div className="step-counter fa-lg fa fa-check"></div>
          <button
            className="step-btn step-name-completed btn btn-lg mt-3"
            type="button"
          >
            {t["Website Creation"]}
          </button>
        </div>
        <div
          className="stepper-item completed go_to_sub"
          style={{ pointerEvents: "none" }}
        >
          <div className="step-counter fa-lg fa fa-check"></div>
          <button
            className="step-btn step-name-completed btn btn-lg mt-3"
            type="button"
          >
            {t["Subscription"]}
          </button>
        </div>
        <div
          ref={add_product}
          onClick={() => handleClickAddProduct()}
          className={`stepper-item add_product ${
            productInfo ? "completed" : ""
          }`}
        >
          <div className="step-counter fa-lg fa fa-check"></div>
          <button
            className={`step-btn ${
              productInfo ? "step-name-completed" : "step-name"
            } btn btn-lg mt-3`}
            type="button"
          >
            {t["Add Product"]}
          </button>
        </div>
        <div
          onClick={() => handleClickAddBankCR()}
          className={`stepper-item add_your_cr ${crInfo ? "completed" : ""}`}
        >
          <div className="step-counter fa-lg fa fa-check"></div>
          <button
            className={`step-btn ${
              crInfo ? "step-name-completed" : "step-name"
            } btn btn-lg mt-3`}
            type="button"
          >
            {t["Add CR | Bank"]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgressMap;
